<template>
    <div id="about">
        <section id="about-section">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-sm-12">
                        <div class="row justify-content-between">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 order-lg-1 order-md-1">
                        <div class="intro-message" data-aos="fade-up" data-aos-duration="1200">
                            <h4 class="h4-title mb-2">The New Standard in </h4>
                            <h1 class="h1-title mb-5">How to Start a Start-Up Without an Investment</h1>

                            <p class="section-description">Nowadays, entrepreneurs face an infinite loop:
                                They need money to build their first product, but they also need a product and users to get that money from angels or VCs.</p>
                            <p class="section-description">We break that loop.</p>
                            <p class="section-description">SPIRITT is an innovative <a class="link" v-scroll-to="'#pricing'">subscription-based</a> solution that allows entrepreneurs and early-stage start-ups to build full-scale software applications without prior knowledge in coding, design, and deployment. In days.</p>
                            <p></p>
                            <p class="section-description">Start today and get the marvelous product you need to get results right away:</p>
                            <p class="font-weight-bold">Validation, users, data, revenues, and even growth.</p>
                            <ul class="mt-5 d-flex p-0 list-unstyled">
                                <li>
                                    <router-link :to="{name: 'quiz', params: {url: 'P4Oy3x'}}" class="btn btn-hero btn-hero-primary mr-3">Start for Free</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

    export default {
        name: 'about',
    }
</script>

<style lang="css" scoped>
    #about-section {
        background-color: #f1f1f1;
        color: #000000;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-top: 30px;
    }
    .h1-title {
        font-size: 2.18rem !important;
        font-weight: 300;
        line-height: 1;
    }
    .h4-title {
        font-size: 0.8rem !important;
        font-weight: 600;
        line-height: 1;
        text-transform: uppercase;
    }
    .intro-message {
        padding-top: 50px;
        padding-bottom: 120px;
    }
    .btn-hero {
        height: 48px;
        min-width: 240px;
        font-weight: bold;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
    }
    .btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
        color: #ffffff;
        background-image: linear-gradient(101deg, #3a71bb 2%, #9232bf 56%, #771bae 96%);
        padding-top: 10px;
        outline: none;
        border: none;
        transition: 0.3s;
    }
    .link{
        color: #3a71bb !important;
        text-decoration: underline !important;
        cursor: pointer;
    }
    .link:hover{
        color: #771bae !important;
    }
    .btn-hero-primary:hover{
        color: #00c092;
        background-image: linear-gradient(101deg, #3a71bb 2%, #9232bf 56%, #771bae 96%);
    }
    .btn-hero-secondary {
        color: #9232bf;
        background: #fff;
    }
    @media (min-width: 768px) {
        .section-description {
            width: 575px;
        }
    }
</style>
